module.exports = __webpack_public_path__ + "static/media/fixedIcon.0246ef96.svg";